import './cookie_handler.js';

document.addEventListener('turbolinks:load', function() {
    const isInIframe = window.location !== window.parent.location
        ? 'embedded in iframe'
        : 'not embedded in iframe'
    storeCookie(isInIframe, 'is_in_iframe');
})